import React, { useEffect } from "react";
import "./Carrier.scss";

import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import Wrapper from "./../../../componentsAdditional/Wrapper";
import CoverCarrier from "./../../../componentsLanding/Landing/Covers/CoverCarrier/CoverCarrier";
import ForAboutCarrier from "./../../../componentsLanding/Landing/Abouts/ForAboutCarrier/ForAboutCarrier";
import JoinUsCarrier from "./../../../componentsLanding/Landing/Joins/JoinUsCarrier/JoinUsCarrier";
import ForWorkflowCarrier from "./../../../componentsLanding/Landing/Workflows/ForWorkflowCarrier/ForWorkflowCarrier";
import ContactCarrier from "./../../../componentsLanding/Landing/Contacts/ContactCarrier/ContactCarrier";
import FaqSectionCarrier from "./../../../componentsLanding/Landing/FAQs/FaqSectionCarrier/FaqSectionCarrier";
import SubscribeCarrier from "../../../componentsLanding/Landing/SubscribeCarrier/SubscribeCarrier";
import WebPlatformCarrier from "../../../componentsLanding/Landing/WebPlatformCarrier/WebPlatformCarrier";
import TmsSolutionCarrier from "../../../componentsLanding/Landing/TmsSolutionCarrier/TmsSolutionCarrier";

const Carrier = () => {
  const { t } = useTranslation();

  const location = useLocation();

  useEffect(() => {
    const scrollToId = location.state?.scrollToId; // ვამოწმებთ გადმოცემულ ID-ს
    if (scrollToId) {
      const element = document.getElementById(scrollToId);
      if (element) {
        const offset = -80; // ეცვლება წანაცვლების სიდიდე, თუ ფიქსირებული header არსებობს
        const elementRect = element.getBoundingClientRect();
        const scrollTop = window.scrollY + elementRect.top + offset;

        window.scrollTo({
          top: scrollTop,
          behavior: "smooth",
        });
      }
    }
  }, [location.state]);

  return (
    <Wrapper documentTitle={t("landing.documentTitles.Carrier")}>
      <CoverCarrier />
      <WebPlatformCarrier />
      <TmsSolutionCarrier />
      <ForWorkflowCarrier />
      <SubscribeCarrier />
      <ForAboutCarrier />
      <JoinUsCarrier />
      <FaqSectionCarrier />
      <ContactCarrier />
    </Wrapper>
  );
};

export default Carrier;
